

$(function () {
    var obj = {
        ModalForm: {
            wireup: function (selector) {
                $(selector).each(function (idx, element) {
                    var opener = $(element).data("opener");
                    var $actionBtn = $(element).find("[data-btn=action]");
                    var $form = $(element).find("form");
                    var $alert = $(element).find("div.alert");
                    var reloadOnSuccess = $(element).data("reload");
                    var redirectOnSuccess = $(element).data("redir");
                    var urlToRedir = $(element).data("redir-url");

                    /**
                     * Displays an error message
                     */
                    var _showMsg = function (msg, isError) {

                        if (isError) {
                            $alert.removeClass("alert-success").addClass("alert-danger");
                            $alert.html(msg || "An unspecified error occurred");
                        }
                        else {
                            $alert.removeClass("alert-danger").addClass("alert-success");
                            $alert.html(msg || "Success!");
                        }

                        $alert.show();
                    };

                    /**
                     * Resets the form
                     */
                    var _reset = function () {
                        $form.get(0).reset();
                    }

                    var _toggleLoading = function (loading) {
                        if (loading)
                            $($actionBtn).addClass("btn-loading").addClass("disabled");
                        else
                            $($actionBtn).removeClass("btn-loading").removeClass("disabled");
                    }

                    /**
                     * Submits the form
                     */
                    var _submit = function () {
                        var data = $form.serialize();
                        var form = $form.get(0);
                        _toggleLoading(true);

                        $.ajax({
                            url: form.action,
                            method: form.method,
                            data: data,
                            success: function (d) {
                                if (!d) {
                                    _showMsg(null, true);
                                    return;
                                }

                                if (d.Success === true) {
                                    _reset();
                                    $(element).trigger(WidgetEvents.ON_SUCCESS);

                                    if (redirectOnSuccess && urlToRedir) {
                                        $(element).modal("hide");
                                        window.location = urlToRedir;
                                    }
                                    else if (reloadOnSuccess) {
                                        $(element).modal("hide");
                                        window.location.replace(window.location);
                                    }
                                    else {
                                        _showMsg(null, false);
                                    }

                                }
                                else if (d.Error) {
                                    _showMsg(d.Error, true);
                                }
                                else {
                                    _showMsg(null, true);
                                }
                            },
                            error: function (x, s, e) {
                                _showMsg(e, true);
                            },
                            complete: function () {
                                _toggleLoading(false);
                            }
                        })
                    };

                    $(element).on("hide.bs.modal", function () {
                        _reset();
                        $alert.hide();
                        _toggleLoading(false);
                    });

                    $("#" + opener).click(function () {
                        $(element).modal("show");
                    });

                    $actionBtn.click(function () {
                        _submit();
                    });
                });
            }
        }
    }

    $.extend(Widgets, obj);
    Widgets.ModalForm.wireup(".widget-modal-form");
})